import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "userQuestionFilled"
const UserQuestionFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.553 20.83C20.117 20.832 20.574 21.29 20.574 21.854S20.118 22.875 19.554 22.875C18.988 22.875 18.53 22.418 18.53 21.853 18.53 21.29 18.988 20.831 19.553 20.831M10.5 13.125C12.573 13.125 14.168 13.523 15.396 14.135 15.204 14.64 15.104 15.176 15.104 15.72 15.104 16.017 15.223 16.303 15.434 16.514 15.644 16.724 15.93 16.844 16.229 16.844H17.916C17.702 17.147 17.576 17.518 17.576 17.918V19.979C17.575 20.219 17.651 20.442 17.78 20.625H1.5S1.5 13.125 10.5 13.125" />
          <path d="M18.28 12.649C18.888 12.398 19.557 12.332 20.2 12.46 20.845 12.588 21.437 12.905 21.902 13.37 22.366 13.834 22.683 14.427 22.812 15.07 22.938 15.715 22.873 16.384 22.621 16.991 22.371 17.598 21.945 18.117 21.398 18.48 21.093 18.687 20.756 18.836 20.404 18.929V19.98H18.7V17.914C18.703 17.502 19.038 17.169 19.45 17.169H19.552V17.167C19.838 17.167 20.118 17.082 20.356 16.923S20.78 16.537 20.89 16.273 21.028 15.717 20.972 15.437C20.916 15.156 20.778 14.897 20.576 14.695 20.373 14.493 20.116 14.355 19.835 14.3S19.262 14.272 18.998 14.381C18.733 14.491 18.507 14.677 18.348 14.915S18.104 15.433 18.104 15.719H16.229C16.229 15.062 16.424 14.42 16.789 13.873S17.674 12.9 18.28 12.649M10.875 1.5C13.567 1.5 15.75 3.683 15.75 6.375S13.567 11.25 10.875 11.25 6 9.067 6 6.375 8.183 1.5 10.875 1.5" />
        </svg>
      }
    </span>
  )
}
export default UserQuestionFilledIcon
